"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var endsWith_1 = __importDefault(require("lodash/endsWith"));
// cars => car, Addresses => Address, boxes => box
// yes this is a hack and should carefully be made smarter or something
// maybe borrow from https://github.com/blakeembrey/pluralize
var singularize = function (word) {
    if ((0, endsWith_1.default)(word, 'sses') || (0, endsWith_1.default)(word, 'xes')) {
        return word.substring(0, word.length - 2);
    }
    return word.substring(0, word.length - 1);
};
exports.default = singularize;
//# sourceMappingURL=singularize.js.map